<template>
  <div>
     <el-card>
      <search-form
        ref="searchForm"
        :topVisible="true"
        :tabData="tabData"
        labelWidth="120px"
        :searchFormData="searchFormData"
        @search="search" @tabChange="tabChange"
      >
         <template #topBtn>
          <el-button class="marginRight20" type="primary" size="small" @click="handleClick({action: 'create'})">{{ $t('text.add') }}</el-button>
        </template>
      </search-form>
      <create-table
        ref="createTable"
        :operationColWidth="150"
        :autoWidth="true"
        :operateVisible="operateVisible"
        :loading="loading"
        :btnType="[]"
        :total_count="pageData.total_count ? pageData.total_count : 0"
        :current_page.sync="pageData.page"
        :papeSize.sync="pageData.per_page"
        :topButtonVisible="true"
        :tableData="tableData"
        :tableDataItem="tableDataItem"
        :pageVisible="true"
        :pageData="pageData"
        @forwardToPage="forwardToPage"
        :checkBoxVisible="true"
        @handleNewTab="handleNewTab($event, 'storesManagerDetail')"
        @selectionChange="selectionChange"
        @operate="handleClick"
      >
        <template #topButton>
          <div class="operate__wrapper">
            <el-select v-model="value1" placeholder="Select Action">
              <el-option
                v-for="item in options1"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <el-button type="primary" icon="el-icon-caret-right" @click="handleOperate"></el-button>
          </div>
          <!-- <span v-if="dropDataItem.length > 0" class="marginRight20 spanminWith">{{`${$t('text.selected')}：${selectionData.length}`}}</span>
          <allButton :buttonDisabled="selectionData.length < 1" :buttonDataItem="dropDataItem" class="marginRight20" @chooseDropItem="chooseDropItem"></allButton> -->
        </template>
        <template #rightBtn="scope">
          <el-button class="margintop10" :class="item.action === 'view' ? 'operate_view' : ''" v-for="(item, index) in scope.row.member_actions.default_actions" :key="'default_actions' + index" :type="item.type && item.type === 'warn' ? 'danger' : 'primary'" size="mini" @click="handleClick(item, scope.row)">{{item.name}}</el-button>
          <el-button class="margintop10" v-for="(item, index) in scope.row.member_actions.custom_actions" :key="'custom_actions' + index" :type="item.type && item.type === 'warn' ? 'danger' : 'primary'" size="mini" @click="handleCusClick(item)">{{item.name}}</el-button>
        </template>
      </create-table>
    </el-card>
    <router-view/>
    <el-dialog title="Set Charging Profile" v-if="dialogFormVisible" width="80%" :visible.sync="dialogFormVisible">
      <chargingSchedule></chargingSchedule>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">Cancel</el-button>
        <el-button type="primary" @click="hanleMessage(); dialogFormVisible = false">Set</el-button>
      </div>
    </el-dialog>
    <dialogEffect v-if="dialogVisible" :opereteDate="false" :todayVisible="true" :dialogVisible.sync="dialogVisible" :data="dialogData" @doNextConfirm="doNextConfirm"></dialogEffect>
  </div>
</template>

<script>
import loading from '@/utils/loading.json'
import apis from '@/services'
import jsonData from './jsonData.js'
import searchForm from '@/components/searchForm'
import createTable from '@/components/createTable'
import dialogEffect from '@/components/dialogEffect'
import chargingSchedule from '@/views/chargingPointManager/add/component/chargingSchedule.vue'
import { mixin } from '@/mixins/mixin'
export default {
  name: 'Transactions',
  mixins: [mixin],
  components: {
    searchForm,
    createTable,
    dialogEffect,
    chargingSchedule
  },
  data () {
    return {
      tableDataItem: jsonData.tableDataItem,
      dialogFormVisible: false,
      options1: [{
        value: 'Start Session',
        label: 'Start Session'
      }, {
        value: 'Reserve',
        label: 'Reserve'
      }, {
        value: 'Unlock',
        label: 'Unlock'
      }, {
        value: 'Set Charging Profile',
        label: 'Set Charging Profile'
      }, {
        value: 'Get Composite Schedule',
        label: 'Get Composite Schedule'
      }, {
        value: 'Triggle Message',
        label: 'Triggle Message'
      }, {
        value: 'Export EVSEs',
        label: 'Export EVSEs'
      }, {
        value: 'Change Avaliability',
        label: 'Change Avaliability'
      }],
      value1: '',
      selectData: []
    }
  },
  created () {
    this.queryData(apis.AssetApi.getEvsesSetup)
  },
  methods: {
    selectionChange (val) {
      this.selectData = val
    },
    // 点击操作按钮
    handleClick (type, data) {
      if (type.action === 'create') {
        this.$router.push({
          name: 'EVSEsAdd'
        })
      } else if (type.action === 'view') {
        this.$router.push({
          name: 'EVSEsDetail',
          params: {
            id: data.id.value
          }
        })
      } else if (type.action === 'edit') {
        this.$router.push({
          name: 'EVSEsAdd',
          params: {
            id: data.id.value
          }
        })
      } else if (type.action === 'destroy') {
        this.deleteClick(data, apis.AssetApi.deleteEvsesRecord)
      }
    },
    forwardToPage (data, name) {
      if (data.model_name && data.model_name === 'charge_point') {
        this.$router.push({
          name: 'chargingPointDetail',
          params: {
            id: data.id
          }
        })
      }
    },
    search (data) {
      if (data) this.searchData = data
      const { page, per_page } = this.pageData
      Object.assign(this.searchData, { page, per_page })
      this.loading = true
      apis.AssetApi.getEvsesList(this.searchData).then(res => {
        if (res.data) {
          this.tableData = res.data.objects
          this.tabData = res.data.scopes
          Object.assign(this.pageData, res.data.pagination)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    handleOperate () {
      if (this.selectData.length < 1) {
        this.$message({
          message: 'Please Select Data.',
          type: 'error'
        })
        return
      }
      if (this.value1 === '') {
        this.$message({
          message: 'Please Select Action.',
          type: 'error'
        })
        return
      }
      if (this.value1 === 'Set Charging Profile') {
        this.dialogFormVisible = true
      } else {
        this.hanleMessage()
      }
    },
    hanleMessage () {
      this.$store.state.app.loading = this.$loading(loading)
      setTimeout(() => {
        this.$store.state.app.loading.close()
        this.$message({
          message: 'The EVSE is currently unavailable.',
          type: 'error'
        })
      }, 500)
    }
  }
}
</script>

<style lang="scss" scoped>
.operate__wrapper {
    border-top: 1.5px solid #EBEEF5;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 12px;
    padding-top: 12px;
    .el-select {
      // border: 1.5px solid #409eff;
      border-radius: 6px;
      width: 200px;
      margin-right: 4px;
    }
    .el-select .el-input.is-focus .el-input__inner {
      border-color: #409eff;
    }
    .el-select .el-input__inner:focus {
      border-color: #409eff;
    }
  }
</style>
